module.exports = __webpack_public_path__ + "img/outlinedClose.98b3df63.png";